import request from '@/utils/request'

// 查询广告信息列表分页
export function fetchList(query) {
    return request({
        url: '/banner/banner/page',
        method: 'get',
        params: query,
    })
}
// 查询筛选使用
export function publicModel(query) {
    return request({
        url: '/fix/model/public/page',
        method: 'get',
        params: query,
    })
}
// 查询广告详细
export function getObj(id) {
    return request({
        url: '/banner/banner/detail?id=' + id,
        method: 'get',
    })
}
// 新增广告
export function addObj(data) {
    return request({
        url: '/banner/banner/add',
        method: 'post',
        data: data,
    })
}

// 修改广告
export function putObj(data) {
    return request({
        url: '/banner/banner/edit',
        method: 'post',
        data: data,
    })
}
// 删除广告
export function delObj(data) {
    return request({
        url: '/banner/banner/delete',
        method: 'post',
        data: data,
    })
}
// 审核广告
export function statusObj(data) {
    return request({
        url: '/banner/banner/auditing',
        method: 'post',
        data: data,
    })
}
// 上下架
export function upState(data) {
    return request({
        url: '/banner/banner/up/state',
        method: 'post',
        data: data,
    })
}